import { getScheduledOrdersConstants } from '../constants';

const getScheduledOrders = (state, action) => {
    if (state === undefined) {
        return {
            data: [],
            loading: true,
            error: false,
            success: false,
        };
    }

    switch (action.type) {
        case getScheduledOrdersConstants.GET_SCHEDULED_ORDERS_REQUEST:
            return {
                data: [],
                loading: true,
                error: false,
                success: false,
            };

        case getScheduledOrdersConstants.GET_SCHEDULED_ORDERS_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: false,
                success: true,
            };

        case getScheduledOrdersConstants.GET_SCHEDULED_ORDERS_FAILURE:
            return {
                data: [],
                loading: false,
                error: true,
                success: false,
            };

        default:
            return state;
    }
};

export default getScheduledOrders;
